<template>
  <div>

    <div style="text-align: center">
      <img src="logo512.png" class="lab-logo" style="width: 156px; height: 156px">
    </div>

    <h1 style="text-align: center">計算機<br v-if="isSp">システム工学研究室</h1>
    <div style="text-align: center">COMPUTER SYSTEM ENGINEERING LABORATORY.</div>

    <h1>研究室について</h1>
    <h2>研究テーマ</h2>
    <h3>次世代を担う高性能チップ</h3>
    <img src="noc.png">
    <div>
    </div>
    <h3>計算アルゴリズムの高速化</h3>
    <img src="camera.png">
    <h3>インターネット上の並列計算</h3>
    <img src="vc.png">
  </div>
</template>

<script>
export default {
  name: 'IndexView',
  computed: {
    isSp() { return window.innerWidth < 500},
  },
  props: {
    msg: String
  }
}
</script>

<style scoped>
  .lab-logo {
    width: 72px;
    height: 72px;
    text-align: center;
  }
  img {
    max-width: 800px;
    width: 100%;
  }
</style>
